<template>
	<v-footer dark padless>
		<v-card class="flex" flat tile>
			<v-row justify="space-around" align="center">
				<v-col cols="12" lg="6" class="footer-text">
					<div>Ronald Tutor Hall (RTH)</div>
					<div>3710 McClintock Ave, Room 423</div>
					<div>Los Angeles, CA 90089-0781</div>
				</v-col>
				<v-col cols="12" lg="3">
					<v-row justify="center">
						<v-col cols="6" align-self="center">
							<a class="link" href="http://viterbi.usc.edu/">
								<img
									alt="Brand"
									id="viterbilogo"
									src="https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/logo%2FViterbi_Transparent_Gold.png?alt=media&token=2f212b85-ef45-4bcd-9e68-a8fc2ade706c"
								/>
							</a>
						</v-col>
						<v-col cols="2" align-self="center">
							<a class="link" href="http://rasc.usc.edu/">
								<img alt="Brand" id="rasclogo" src="https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/logo%2Frasclogo.png?alt=media&token=dcb30d45-a878-4731-a4d8-ad04945f2bbc" />
							</a>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-card>
	</v-footer>
</template>


<script>
export default {
	data: () => ({
		icons: [
			"fab fa-facebook",
			"fab fa-twitter",
			"fab fa-google-plus",
			"fab fa-linkedin",
			"fab fa-instagram"
		]
	})
};
</script>

<style lang="scss">
#rasclogo {
	width: 100%;
}

#viterbilogo {
	width: 100%;
}
/**
 * following are responsive support
 */
@media (max-width: 420px) {
	.footer-text {
		text-align: center;
	}

	.row {
		margin-right: 0 !important;
	}
}
</style>
